import { useCallback, useMemo } from 'react';
import {
  paymentsActions,
  STORE_PROPS,
  useGetPaymentSystemsByType,
  usePaymentsStore
} from '../../store';
import { createPaymentMethod } from './createPaymentMethod';

const { ACTIVE_SERVICE_ID, ACTIVE_PAYMENT_TYPE } = STORE_PROPS;

const { SET_ACTIVE_SERVICE } = paymentsActions;

export const usePaymentMethodsCarousel = () => {
  const paymentsServices = useGetPaymentSystemsByType();

  const { activeServiceId: serviceId, activePaymentType } = usePaymentsStore([
    ACTIVE_SERVICE_ID,
    ACTIVE_PAYMENT_TYPE
  ]);

  const paymentMethods = useMemo(
    () =>
      paymentsServices.map(createPaymentMethod(activePaymentType as string)),
    [activePaymentType, paymentsServices]
  );

  const onSelect = useCallback((newServiceId: number) => {
    SET_ACTIVE_SERVICE(newServiceId);
  }, []);

  return {
    paymentMethods,
    selectedPaymentMethodId: serviceId,
    onSelect
  };
};
